const common = {
  activeFilters_one: '{{count}} filtre actif',
  activeFilters_other: '{{count}} filtres actifs',
  add: 'Ajouter',
  addComment: 'Ajouter un commentaire',
  admin: 'Administration',
  after: 'Après',
  and: 'et',
  anyDueDate: 'Toutes',
  anyImportance: 'Toutes',
  applyFilters: 'Appliquer',
  archive: 'Archiver',
  assignee: 'Responsable',
  assignees: 'Responsables',
  backToHome: 'Retour à l\'accueil',
  blocked: 'Bloqué',
  boolean: 'Booléen',
  cancel: 'Annuler',
  cancelled: 'Annulé',
  cancelReason: 'Raison de l\'annulation',
  cancelReasonPlaceholder: 'Pourquoi ceci est-il annulé ?',
  cancelReasonPrompt: 'Pourquoi ceci est-il annulé ?',
  cardsView: 'Vue cartes',
  clearFilters: 'Effacer',
  collapse: 'Replier',
  color: 'Couleur',
  comment: 'Commentaire',
  comments: 'Commentaires',
  commentTooLong: 'Un commentaire peut contenir au maximum {{max}} caractères.',
  completed: 'Completé',
  completion: 'Complétion',
  confirmCancellation: 'Marquer comme annulé',
  couldNotSaveComment: 'Impossible d\'enregistrer le commentaire.',
  couldNotSaveTask: 'Impossible d\'enregistrer la tâche.',
  create: 'Créer',
  created: 'Créé',
  custom: 'Personnalisé',
  daily: 'Quotidien',
  date: 'Date',
  day: 'Jour',
  dayOfMonth: 'Jour du mois',
  daysOfWeek: 'Jours de la semaine',
  deadline: 'Échéance',
  delete: 'Supprimer',
  deleted: 'Supprimé',
  description: 'Description',
  details: 'Détails',
  discussion: 'Discussion',
  documentation: 'Documentation',
  doing: 'En cours',
  dueDate: 'Date d\'échéance',
  dueThisWeek: 'Cette semaine',
  dueToday: 'Aujourd\'hui',
  duplicate: 'Dupliquer',
  duration: 'Durée',
  edit: 'Modifier',
  edited: 'modifié',
  end: 'Fin',
  ends: 'Se termine',
  expand: 'Déplier',
  exportToCsv: 'Exporter en CSV',
  failed: 'Échoué',
  feedback: 'Votre opinion',
  fields: 'Champs',
  filters: 'Filtres',
  friday: 'Vendredi',
  history: 'Historique',
  home: 'Accueil',
  hour: 'Heure',
  hours: 'Heures',
  icon: 'Icône',
  importance: 'Importance',
  importanceHigh: 'Haute',
  importanceLow: 'Faible',
  importanceMedium: 'Moyenne',
  informations: 'Informations',
  invalidSubmission: 'Soumission invalide',
  last: 'Dernier',
  lastUpdate: 'Dernière mise à jour',
  listView: 'Vue liste',
  loading: 'Chargement',
  markAsCancelled: 'Marquer comme annulé',
  markAsCompleted: 'Marquer comme complété',
  monday: 'Lundi',
  month: 'Mois',
  monthly: 'Mensuel',
  name: 'Nom',
  never: 'Jamais',
  no: 'Non',
  noCommentsToDisplay: 'Aucun commentaire à afficher',
  noDueDate: 'Sans échéance',
  noImportance: 'Sans importance',
  noFieldsToDisplay: 'Aucun champ à afficher',
  noHistoryToDisplay: 'Aucun historique à afficher',
  noSearchResults: 'Aucun résultat ne correspond à votre recherche',
  note: 'Note',
  notDone: 'Non fait',
  notifications: 'Notifications',
  nthWeekday: 'Jour de la semaine',
  number: 'Nombre',
  occurrences: 'occurrences',
  onDate: 'À une date',
  onThe: 'Le',
  openInFullPage: 'Ouvrir en pleine page',
  or: 'ou',
  ordinalFifth: 'Cinquième',
  ordinalFirst: 'Premier',
  ordinalFourth: 'Quatrième',
  ordinalSecond: 'Deuxième',
  ordinalThird: 'Troisième',
  overdue: 'En retard',
  pageNotFound: 'Page introuvable',
  pageNotFoundDescription: 'Cette page n\'existe pas, ou vous n\'y avez pas accès.',
  privacy: 'Confidentialité',
  progress: 'Progrès',
  recurrence: 'Récurrence',
  reopen: 'Réouvrir',
  repeatEvery: 'Répéter tous les',
  required: 'Requis',
  saturday: 'Samedi',
  save: 'Sauvegarder',
  search: 'Recherche',
  searchResults: 'Résultats de recherche',
  selectAtMostXItems: 'Veuillez sélectionner au plus {{count}} éléments.',
  showingXToYOfZ: 'Affichage de {{from}}–{{to}} sur {{total}}',
  start: 'Début',
  startDate: 'Date de début',
  stats: 'Statistiques',
  status: 'Statut',
  sunday: 'Dimanche',
  termsOfService: 'Conditions d\'utilisation',
  text: 'Texte',
  thursday: 'Jeudi',
  time: 'Temps',
  timeLeft: 'Temps restant',
  timesheet: 'Feuille de temps',
  todo: 'À faire',
  tuesday: 'Mardi',
  type: 'Type',
  unassigned: 'Non assigné',
  unknownUser: 'Utilisateur inconnu',
  version: 'v{{version}}',
  wednesday: 'Mercredi',
  week: 'Semaine',
  weekly: 'Hebdomadaire',
  writeAComment: 'Écrire un commentaire',
  year: 'Année',
  yearly: 'Annuel',
  yes: 'Oui',
};

export default common;
